import React from 'react';
import { FiAlertTriangle, FiRefreshCw } from 'react-icons/fi';

import type { WorkflowTypeStatsData } from '../../../services/analyticsService';

const PALETTE = ['#a200ff', '#00b0d3', '#22c55e', '#f59e0b', '#3b82f6'];

interface Props {
  workflowTypeStats: WorkflowTypeStatsData | null;
  isLoading: boolean;
  error: string | null;
  onRetry: () => void;
}

const TriggerStatsWidget: React.FC<Props> = ({
  workflowTypeStats,
  isLoading,
  error,
  onRetry
}) => {
  const triggers = (workflowTypeStats?.top_triggers ?? []).slice(0, 5);
  const max = Math.max(1, ...triggers.map(t => t.workflows_count));

  return (
    <div className='dw-card'>
      <div className='dw-card__label'>Top Triggers</div>
      {isLoading ? (
        <div className='mws-skeletons' style={{ marginTop: 8 }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className='dw-skel mws-skel-row' />
          ))}
        </div>
      ) : error ? (
        <div className='mws-error'>
          <span className='mws-error__msg'>
            <FiAlertTriangle size={12} /> {error}
          </span>
          <button onClick={onRetry} className='mws-error__retry'>
            <FiRefreshCw size={10} /> Retry
          </button>
        </div>
      ) : triggers.length === 0 ? (
        <div className='mws-empty'>No trigger data</div>
      ) : (
        <div className='mws-trigger-list'>
          {triggers.map(({ trigger, workflows_count }, i) => {
            const color = PALETTE[i % PALETTE.length];
            return (
              <div key={trigger}>
                <div className='mws-trigger-row__header'>
                  <span className='mws-trigger-row__label'>
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: color,
                        display: 'inline-block',
                        flexShrink: 0
                      }}
                    />
                    {trigger}
                  </span>
                  <span className='mws-trigger-row__count'>
                    {workflows_count}
                  </span>
                </div>
                <div className='mws-trigger-row__track'>
                  <div
                    className='mws-trigger-row__fill'
                    style={{
                      background: color,
                      width: `${(workflows_count / max) * 100}%`
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TriggerStatsWidget;
